import { imageUpload } from "./api_helper"

class CustomUploadAdapter {
  constructor(loader) {
    this.loader = loader
  }

  upload() {
    return this.loader.file.then(
      file =>
        new Promise(async (resolve, reject) => {
          const formData = new FormData()
          formData.append("file", file)

          try {
            const { data } = await imageUpload(formData)

            resolve({
              default: data.image_path_full,
            })
          } catch (error) {
            reject("Upload failed")
          }
        })
    )
  }

  abort() {
    // Abort upload if needed
  }
}

export function CustomUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = loader => {
    return new CustomUploadAdapter(loader)
  }
}
